<template>
  <div>
    <CCard>
      <CCardBody class="profile-home">
        <div class="user-info-table" v-if="TopInfo">
          <CForm class="modal-form">
            <!-- <CRow>
              <CCol lg="12" class="px-0 mb-3">
                <h4 class="sub-title">ご利用規約</h4>
              </CCol>
            </CRow> -->
            <CRow>
              <CCol class="overflow-section border p-1 mb-2">
                <div class="terms_and_condition">
                  <strong>【ご利用規約】</strong>
                  <p>
                    本規約は、株式会社リバティー（以下「弊社」といいます）の運営する施設およびWEBサイト（以下「本サービス」という）の利用条件について定めるものです。
                  </p>

                  <strong>第1条(会員資格)</strong>
                  <p>
                    入会は以下の規約に同意いただき、所定の会員登録手続きを完了された方といたします。
                  </p>

                  <strong>第2条(基本合意)</strong>
                  <p>
                    本サービスの利用については会員の責任となります。また、会員は本規約を承諾したうえで本サービスを利用するものとします。弊社が本サービス通じて随時会員に向けて発表する諸規定は、本規約の一部を構成し、会員はこれを承諾したうえで本サービスを利用するものとします。この規約は任意に変更することがあり、変更後に本サービスの利用があった場合には、会員はこの変更を承諾したものとします。<br />
                  </p>

                  <strong>第3条(会員)</strong>
                  <p>
                    1.弊社所定の登録手続きから氏名・生年月日・電話番号・メールアドレス・会員が任意に設定するパスワードなど(以下「会員情報」といいます)を弊社の定める方法に従って登録された方を会員とします。<br />
                    2.会員は、登録した会員情報が真実であることを保証するものとし、弊社は、会員情報に基づいてのみ本サービスの利用を承諾するものとします。<br />
                    3.次に該当する場合は、会員となることはできず、会員登録終了後においても、弊社の判断で会員資格を喪失することがあります。<br />
                    (1)会員が実在しない場合<br />
                    (2)過去に本規約違反などにより、会員資格の停止又は取消しが行われている場合<br />
                    (3)会員情報に、虚偽の記載、誤記、又は記入漏れがあった場合<br />
                    (4)弊社の業務の遂行上又は技術上支障がある場合<br />
                    (5)会員が本規約に違反した場合<br />
                    (6)その他、弊社が会員であることを不適当と判断した場合<br />
                    4.弊社が会員に連絡、通知する場合、会員情報に登録された電話番号への連絡、メールアドレスへの送信をもって到達したものとみなします。
                  </p>

                  <strong>第4条(個人情報の利用目的)</strong>
                  <p>
                    ご登録頂いた個人情報は弊社内で共有し、ご挨拶や弊社提供の特典情報および宿泊プラン、通信販売等の新商品のご案内や、各種関連商品の販売、勧誘、広告及び宣伝物の送付、送信（電子メールを含む。）、ご案内、弊社内部における市場調査及び分析並びに商品及びアフターサービスの研究、開発及び実施のために利用いたします。
                  </p>

                  <strong>第5条(会員情報の取扱い)</strong>
                  <p>
                    1.本条にいう会員情報とは、ご登録いただいた個人情報、会員もしくは会員の代表者個人に関する氏名（フリガナを含む）、住所、電話番号、生年月日、ご職業、メールアドレス、クレジットカード情報、取引履歴、弊社に対して発生する料金の支払状況、その他届け出た情報とします。<br />
                    2.本規約による義務の履行または権利行使のために、弊社は会員情報を保存し管理するものとします。<br />
                    3.弊社は、本条第2項及び以下の各号に定める場合を除いて、第三者に対し会員情報の開示を行わないものとします。<br />
                    (1)会員が同意する場合<br />
                    (2)弊社が実施する懸賞に当選した会員に関して、当選者の氏名及び住所の存する都道府県名を公表する場合<br />
                    (3)法令により開示が求められた場合<br />
                    (4)本サイト上での会員の行為が、法令または利用規約等に反し、弊社の権利、財産が侵害されるおそれがある場合や、本サービスの提供に支障があると認められる場合<br />
                    (5)裁判所、検察官、警察、弁護士会、消費者センターまたはこれに準じた権限を有する機関から、会員の登録内容についての開示が求められた場合<br />
                    4.弊社は、会員情報の管理には最大限の努力を払いますが、万が一、第三者による故意のハッキング等により生じた情報漏洩やこれに伴い会員に生じた損害すべてに対し、いかなる責任も負わないものとします。
                  </p>

                  <strong>第6条(会員情報の開示・訂正・削除等)</strong>
                  <p>
                    弊社の定める方法に従い、会員から会員情報の利用目的の通知、開示、訂正、利用停止等の請求がある場合、弊社は請求があった会員本人もしくは会員の代表者に関するこれらの開示、修正等を行うものとします。なお、開示、訂正等の請求は以下に連絡するものとします。<br />
                    連絡先メールアドレス：ask@liberty-resort.jp
                  </p>

                  <strong>第7条(設備等)</strong>
                  <p>
                    会員は、本サービスを利用するために必要な通信機器、その他の機器を自己の負担において、準備するものとします。また、自己費用で電気通信サービスを利用してサーバーへ接続するものとします。必要な手続きは会員が自己の責任と費用で行なうものとします。
                  </p>

                  <strong>第8条(禁止事項)</strong>
                  <p>
                    1.本サービスの利用に際し、会員は次号に該当する行為を行うことはできません。<br />
                    (1)法令又は本規約、公序良俗に反する行為<br />
                    (2)第三者の権利、利益を侵害する行為又は第三者の迷惑になる行為<br />
                    (3)未成年者に対し悪影響があると判断される行為<br />
                    (4)本サービスの運営を妨げ、又は、本サイトもしくは弊社の信用を毀損する行為<br />
                    (5)本サービスを通じて入手した情報を私的使用目的以外の方法で利用し、又は第三者に同様の行為をさせる行為（但し、弊社が承認した場合は除く）<br />
                    2.会員の行為が前項に該当すると弊社が判断した場合、弊社は会員に対し当該行為の停止を求めることができるほか、会員資格の喪失を決定することができるものとします。
                  </p>

                  <strong>第9条(会員間の情報)</strong>
                  <p>
                    1.会員は、自己の責任と良識に従って本サービスを利用するものとし、利用に際して、弊社、第三者に迷惑をかけないものとします。<br />
                    2.会員同士でなされた情報の授受、およびそれに付随して行われる行為について弊社は一切責任を負わないものとします。<br />
                    3.会員同士あるいは弊社と会員とでなされた情報の授受に関して、当該情報が各種WEB上のウィルス等に感染していたことにより弊社やその他の第三者が損害を蒙った場合、当該情報を掲載した会員はその損害を賠償するものとします。また、本サービスは当該損害について会員または第三者について一切責任を負わないものとします。
                  </p>

                  <strong>第10条(権利の帰属)</strong>
                  <p>
                    本サービスを通じて会員から提供された情報や作品その他のコンテンツに関する知的財産権（著作権その他のノウハウ等）は、すべて弊社に帰属するものとします。
                  </p>

                  <strong>第11条(本サービスの内容の変更および停止)</strong>
                  <p>
                    弊社は予告なく本サービスの内容の変更、利用停止または中止をすることができるものとします。この変更、停止、中止などについては、本サービスを通じて発表するものとします。この場合に会員または第三者に生じた損害については、弊社はいかなる責任も負わないものとします。
                  </p>

                  <strong>第12条(一時的な中断)</strong>
                  <p>
                    弊社は、以下の各号に該当する場合には事前に連絡することなく本サービスを一時的に中断することができるものとします。<br />
                    (1)本サイトのシステムの保守、点検、修理、変更を定期的にまたは緊急に行なう場合<br />
                    (2)火災、停電などにより提供ができなくなった場合<br />
                    (3)地震、噴火、洪水、津波などの天災により提供ができなくなった場合<br />
                    (4)戦争、変乱、暴動、騒乱、労働争議などにより提供ができなくなった場合<br />
                    (5)その他、運用上、技術上本サービスが一時的な中断を必要と判断した場合
                  </p>

                  <strong>第13条(本サービスの内容の保証および中断)</strong>
                  <p>
                    弊社は、本サイトに関して提供する情報、会員が登録する情報について、そのいかなる保証も行ないません。弊社は、理由の如何を問わず、本サイトの提供の遅延または中断などが発生し、その結果会員または他の第三者が損害を被ったとしても当該損害について一切の責任を負わないものとします。
                  </p>

                  <strong>第14条(損害賠償)</strong>
                  <p>
                    1.本サービスの利用により発生した会員の損害すべてに対し、弊社はいかなる責任も負わないものとします。損害には第三者による故意のハッキング等により生じた情報漏洩を含みます。また、弊社が会員の登録、掲載した情報を削除し、会員資格を停止し、抹消し、本サービスを停止、中断、中止したことにつき、弊社は事由の如何を問わず、いかなる責任も負わないものとします。<br />
                    2.会員が本サービスの利用によって他の会員や第三者に対して損害を与えた場合、会員は自己の責任と費用をもって解決し、弊社に損害を与えることのないものとします。
                  </p>

                  <strong>第15条(専属的合意管轄裁判所)</strong>
                  <p>
                    会員と弊社との間で訴訟の必要が生じた場合、静岡地方裁判所もしくは静岡簡易裁判所を専属的合意管轄裁判所とします。
                  </p>

                  <p>令和2年10月23日制定</p>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label class="check-inline">
                  <input
                    type="checkbox"
                    v-model="withdrawalAgree"
                  />
                  <span>ご利用規約に同意する。</span>
                </label>
                <p>（同意にチェック後、「登録」ボタンが表示されます。）</p>
              </CCol>


            </CRow>
          </CForm>
          <CButton
            :disabled="!withdrawalAgree"
            @click="withdrawalConfirmModal = true; TopInfo = false"
            color="danger"
            ><i class="icon cil-trash"></i> 退会する</CButton
          >
        </div>
        <!-- TopInfo end  -->
        <div class="confirm-box" v-if="withdrawalConfirmModal">
          <h5 class="mb-2">退会手続き最終確認</h5>
          <CAlert color="warning">
            <p>退会してよろしいですか？</p>
          </CAlert>
          <CRow>
            <CCol>
              <!-- <CButton
                @click="closeWithdrawalConfirmModal()"
                color="secondary"
                class="float-left"
                ><i class="icon cil-x"></i> キャンセル</CButton
              > -->
              <CButton @click="withdrawalProfileRun()" color="danger"
                ><i class="icon cil-trash"></i> 退会</CButton
              >
            </CCol>
          </CRow>
        </div>

        <CAlert color="success" v-if="successModal">
          更新が完了しました。
        </CAlert>
      </CCardBody>
    </CCard>

    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorModal"
    >
      <p>{{ errorMessage }}</p>
      <template #header>
        <h4 class="modal-title">Error</h4>
      </template>
      <template #footer>
        <CButton @click="errorModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
    <!-- <CModal
      :show.sync="withdrawalModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="xl"
      color="dark"
    >
      <template #header>
        <h5>退会手続き</h5>
      </template>

      <template #footer>
        <CButton @click="closeWithdrawalModal()" color="secondary"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton
          v-if="withdrawalAgree"
          @click="withdrawalConfirmModal = true"
          color="danger"
          ><i class="icon cil-save"></i> 退会する</CButton
        >
      </template>
    </CModal> -->

    <!-- 退会手続き最終確認 -->
    <!-- <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="withdrawalConfirmModal"
      size="l"
    >
      <p>退会してよろしいですか？</p>
      <template #header>
        <h4>退会手続き最終確認</h4>
      </template>
      <template #footer>
        <CButton
          @click="closeWithdrawalConfirmModal()"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> キャンセル</CButton
        >
        <CButton @click="withdrawalProfileRun()" color="danger"
          ><i class="icon cil-pencil"></i> 退会</CButton
        >
      </template>
    </CModal> -->
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  maxLength,
  numeric,
  helpers,
} from "vuelidate/lib/validators";
import FamilyMember from "../../components/FamilyMember";
import Options from "../../components/Options";

// import historykana from "historykana";
// import * as wanakana from "wanakana";

const avatar_url =
  "https://gaa9xd7j0g.execute-api.ap-northeast-1.amazonaws.com/develop";
const zipcode_url =
  "https://jxamy7mdqg.execute-api.ap-northeast-1.amazonaws.com/api/";
const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

const limited = {
  familyName: { maxLength: 100 },
  givenName: { maxLength: 100 },
  firstName: { maxLength: 100 },
  lastName: { maxLength: 100 },
  mobile: { maxLength: 20 },
  address: {
    zipCode: { maxLength: 10 },
    state: { maxLength: 255 },
    city: { maxLength: 255 },
    address1: { maxLength: 255 },
    address2: { maxLength: 255 },
  },
};

export default {
  components: {
    // FamilyMember,
  },
  name: "Profile",
  data() {
    return {
       
      furigana: "",
      newEmail: "",
      history: [],
      ModalTitle: "",
      errorMessage: "",
      TopInfo: true,
      editingModal: false,
      ConfirmModal: false,
      successModal: false,
      errorModal: false,
      withdrawalModal: false,
      withdrawalAgree: false,
      withdrawalConfirmModal: false,
      withdrawalCompleteModal: false,
      codeOptions: [],
      countryOptions: [],
      options: Options.data(),
      user: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        cardId: "",
        email: "",
        emailVerified: true,
        countryCode: "",
        mobile: "",
        address: {
          state: "",
          city: "",
          address1: "",
          address2: "",
          zipCode: "",
          country: {
            id: "",
            name: "",
            fullName: "",
            alpha2: "",
            alpha3: "",
            dial: "",
            flagData: "",
          },
        },
        picture: "",
      },

      avatar: {
        image: "",
        previewImage: "",
        type: "",
      },
      limited: limited,
    };
  },
  validations: {
    withdrawalModal: {
      required: { allowFalse: false },
    },
    itemToEdit: {
      familyName: {
        required,
        maxLength: maxLength(limited.familyName.maxLength),
      },
      givenName: {
        required,
        maxLength: maxLength(limited.givenName.maxLength),
      },
      firstName: {
        required,
        isKana,
        maxLength: maxLength(limited.firstName.maxLength),
      },
      lastName: {
        required,
        isKana,
        maxLength: maxLength(limited.lastName.maxLength),
      },
      gender: { required },
      birth: { required },
      mobile: {
        required,
        numeric,
        maxLength: maxLength(limited.mobile.maxLength),
      },
      address: {
        country: { required },
        zipCode: {
          required,
          maxLength: maxLength(limited.address.zipCode.maxLength),
        }, // Note: US9桁
        state: {
          required,
          maxLength: maxLength(limited.address.state.maxLength),
        },
        city: {
          required,
          maxLength: maxLength(limited.address.city.maxLength),
        },
        address1: {
          required,
          maxLength: maxLength(limited.address.address1.maxLength),
        },
        address2: { maxLength: maxLength(limited.address.address2.maxLength) },
      },
    },
    newEmail: { required, maxLength: maxLength(100) },
  },
  filters: {
    genderString: function (value) {
      if (!value) return "公開しない";
      var retString;
      switch (value) {
        case "UNKONWN":
          retString = "公開しない";
          break;
        case "MALE":
          retString = "男性";
          break;
        case "FEMALE":
          retString = "女性";
          break;
        default:
          retString = "未知";
          break;
      }
      return retString;
    },
    emailVerifiedString: function (value) {
      if (!value) return "不明";
      switch (value) {
        case true:
          return "承認済み";
        case false:
          return "未承認";
        default:
          return "不明";
      }
    },
  },

  methods: {
    getUserInformation: function () {
      //Login as registered user
      var urlRequest = "/rest/currentuser";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.user = resp.data;
          console.log("User Data:" + JSON.stringify(this.user));
          FamilyMember.methods.setFullName(this.fullName);
          // this.downloadAvatar();
        })
        .catch((err) => {
           

          console.log(err);
        });
    },
    getCountries: function () {
      //Login as registered user
      var urlRequest = "/rest/country";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("getCountries:" + JSON.stringify(resp.data));

          this.countryOptions = [];
          this.codeOptions = [];
          resp.data.forEach((element) => {
            this.countryOptions.push({
              value: element.id,
              label: element.name,
            });
            // 国際電話の国番号をセット
            this.codeOptions.push({
              value: element.dial,
              label: element.name + " (" + element.dial + ")",
            });
          });
        })
        .catch((err) => {
           

          console.log(err);
        });
    },

    // get date information
    getDateString: function (dateItem) {
      var today;
      if (dateItem) {
        today = new Date(dateItem);
      } else {
        today = new Date();
      }

      var dateString =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      return dateString;
    },

    onAvatarChange: function (e) {
      // CInputFile の場合
      const files = e;

      this.avatar.type = files[0].type;
      console.log("this.avatar.type: " + this.avatar.type);

      this.getBase64(files[0])
        .then((avatar) => (this.avatar.previewImage = avatar))
        .catch((error) =>
          this.setError(error, "画像のアップロードに失敗しました。")
        );
    },
    getBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getAddress: function () {
      // Get address by zipcode
      const urlRequest =
        zipcode_url + "?postcode=" + this.itemToEdit.address.zipCode;

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log("resp.data: ", resp.data);
          this.itemToEdit.address.state = resp.data.PrefecturesName;
          this.itemToEdit.address.city =
            resp.data.CityName + resp.data.TownName;
        })
        .catch((err) => {
           
          console.log(err);
        });
    },

    resetProfile: function () {
      // 入力内容をリセット
      // note: Object.assign() は itemToEdit が user の参照になってしまうため却下
      //   例) this.itemToEdit = Object.assign({}, this.user);
      // note: スプレッド構文は、ネストしたオブジェクトが参照になるため却下
      //   例）this.itemToEdit = { ...this.user };
      //
      this.itemToEdit = JSON.parse(JSON.stringify(this.user));

      this.avatar.previewImage = this.avatar.image;
      this.avatar.type = "";
    },
    uploadAvatar: async function () {
      const urlRequest = avatar_url;
      const header = { headers: { ContentType: this.avatar.type } };
      // todo: ここでリサイズ処理が必要（100x100など）
      // todo-memo: 2020/09/25時点で resize-base64(動かない), sharp(node v12は動かない?), canvas(よくわからない)
      const original = this.avatar.previewImage.replace(
        /^data:\w+\/\w+;base64,/,
        ""
      );

      await axios
        .put(urlRequest, original, header)
        .then((resp) => {
          console.log("uploadAvatar:");
          console.log(resp.data);
          this.itemToEdit.picture = resp.data.key;
        })
        .catch((err) => {
           

          console.log("Upload avatar error: " + err);
          this.errors = err;
        });
    },
    downloadAvatar: function () {
      const key = this.user.picture;
      const urlRequest = avatar_url + "?key=" + key;
      const type = String(key).slice(".")[1]; // 拡張子を取得

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log(resp);
          this.avatar.image = "data:image/" + type + ";base64," + resp.data;
          this.avatar.previewImage = this.avatar.image;
        })
        .catch((err) => {
           

          console.log("Download avatar error: " + err);
          this.errors = err;
        });
    },

    // TODO: 仕様確認
    /**
     * カードID編集ボタンクリック
     */
    onCardIdEditClick() {
      this.editCardIdModal = true;
    },
    requiredM() {
      this.$v.newEmail.$touch();
    },

    /**
     * 退会内容モーダル表示
     */
    openwithdrawalModal: function () {
      this.withdrawalAgree = false;
      this.withdrawalModal = true;
    },

    /**
     * 退会内容確認モーダル閉じる
     */
    closeWithdrawalModal: function () {
      this.withdrawalModal = false;
    },

    /**
     * 退会最終確認モーダル閉じる
     */
    closeWithdrawalConfirmModal: function () {
      this.withdrawalConfirmModal = false;
      this.closeWithdrawalModal();
    },

    /**
     * 退会最終確認モーダル退会押下
     */
    withdrawalProfileRun: function () {
      this.TopInfo = false;
      this.withdrawalModal = false;
      this.withdrawalConfirmModal = false;
      var urlRequest;
      urlRequest = "/rest/users/" + this.user.name + "/status";
      console.log(this.user.name);
      axios
        .put(
          urlRequest,
          { enabled: false },
          {
            headers: { Authorization: `Bearer ${this.$keycloak.token}` },
          }
        )
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          //this.getUserInformation();
          this.$router.push("/logout");
        })
        .catch((err) => {
           

          // this.completedModal = true;
          // this.memberFormReset();
          // this.scrollTop();
          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },
  },
  beforeMount() {
    this.getUserInformation();
  },
  computed: {
    fullName() {
      return this.user.familyName + " " + this.user.givenName;
    },
  },
};
</script>
<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  .card-body {
    .alert {
      font-size: 0.85rem;
    }
    .form-row {
      margin: 0 0 1rem;
    }
    .col-sm-3 {
      width: 30%;
    }
    .col-sm-9 {
      width: 70%;
      padding-left: 2%;
    }
    .form-row {
      margin: 0;
    }
    .text-danger {
      padding-left: 32%;
    }
  }
}
.p-center {
  margin: 0 auto;
  display: table;
}
.overflow-section {
  max-height: 75vh;
  overflow-y: auto;
}
</style>
